import "./YouTubeEmbed.scss";

interface Props {
  embedCode: string;
  aspectRatio?: "16/9" | "9/16";
  autoPlay?: boolean;
  playOnHover?: boolean;
  title?: string;
}

const ratioMap = {
  "16/9": 56.25,
  "9/16": 177.78,
};

const YouTubeEmbed = ({
  embedCode,
  autoPlay = false,
  playOnHover = false,
  aspectRatio = "16/9",
  title = "Video fra YouTube",
}: Props) => {
  const padding = ratioMap[aspectRatio];

  // Base embed URL
  const baseUrl = `https://www.youtube.com/embed/${embedCode}?rel=0&controls=0${autoPlay ? "&autoplay=1" : ""}`;

  // URL for hover autoplay (muted)
  const hoverUrl = `${baseUrl}&autoplay=1&mute=1&modestbranding=1&playsinline=1`;
  return (
    <div
      className="youtube-embed-react"
      style={{ paddingBottom: `${padding}%` }}
    >
      <iframe
        src={playOnHover ? hoverUrl : baseUrl}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      />
    </div>
  );
};
export default YouTubeEmbed;
